import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TabContainer } from '../components/Tabs/TabGroup';
import { Row, Col, Card } from 'react-bootstrap';
import { CustomFieldForm } from './CustomFieldForm';
import { mockDefinition, mockListDefinition } from './mocks';
import { ListForm } from '../components/Form/ListForm';
import { generateDefaultValues } from '../components/Form/utils';
import { useCallback, useState } from 'react';
import { ListView } from './ListFormTest';
export const FormTest = (props) => {
    // used for setting active index for item in list
    const [activeIndex, setActiveIndex] = useState(null);
    // passed with useCallback to prevent rerendering
    const onIndexChange = useCallback((index) => {
        setActiveIndex(index);
    }, []);
    return (_jsx(Card, Object.assign({ className: 'p-3 w-100' }, { children: _jsx(Row, { children: _jsx(Col, { children: _jsx(TabContainer, { tabs: [
                        {
                            eventKey: 'inputs',
                            label: 'Inputs',
                            content: (_jsx(CustomFieldForm, Object.assign({}, props, { definition: mockDefinition })))
                        },
                        {
                            eventKey: 'lists',
                            label: 'Lists',
                            content: (_jsxs(_Fragment, { children: [_jsx(ListView, { path: 'list', control: props.control, activeIndex: activeIndex, onIndexChange: onIndexChange }), _jsx(ListForm, Object.assign({ activeIndex: activeIndex, onIndexChange: onIndexChange, defaultValues: generateDefaultValues(mockListDefinition), path: 'list', definitionList: mockListDefinition }, props))] }))
                        },
                        {
                            eventKey: 'rules',
                            label: 'Rules',
                            content: _jsx("div", { children: "Rules" })
                        }
                    ], variant: 'subtab' }) }) }) })));
};
